var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-primary",attrs:{"role":"button","title":_vm.local.last_name + ' ' + _vm.local.first_name},on:{"click":_vm.click}},[_c('span',{staticClass:"badge text-capitalize",class:_vm.local.active === 1 ? 'badge-soft-primary bg-secondary' : 'badge-soft-danger'},[_vm._v(" "+_vm._s(_vm.local)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }